import get from 'lodash.get';
import { constants } from '@yola/subscription-manager-js';

const {
  hostingPackageFeatureNames: { ADVANCED_WEBSITE_CUSTOMIZATION },
} = constants;

const advancedWebsiteCustomizationLimit = ({ targetPackage }) => ({
  available: get(targetPackage, ['features', ADVANCED_WEBSITE_CUSTOMIZATION], false),
});

export default advancedWebsiteCustomizationLimit;
